import { useEffect, useMemo } from 'react';

interface ConfettiProps {
  show: boolean;
  onComplete?: () => void;
}

const COLORS = ['#10B981', '#FF6B35', '#F59E0B', '#3B82F6', '#EC4899'];

function generatePieces() {
  return Array.from({ length: 50 }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    delay: Math.random() * 200,
    duration: 2000 + Math.random() * 1000,
    color: COLORS[Math.floor(Math.random() * COLORS.length)],
  }));
}

export function Confetti({ show, onComplete }: ConfettiProps) {
  // Regenerate pieces each time show becomes true so animations replay
  const pieces = useMemo(() => (show ? generatePieces() : []), [show]);

  useEffect(() => {
    if (!show) return;
    const timer = setTimeout(() => {
      onComplete?.();
    }, 3500);
    return () => clearTimeout(timer);
  }, [show, onComplete]);

  if (!show) return null;

  return (
    <div className="fixed inset-0 pointer-events-none z-50 overflow-hidden">
      {pieces.map((piece) => (
        <div
          key={`${piece.id}-${piece.left}`}
          className="absolute w-2 h-2 rounded-full"
          style={{
            left: `${piece.left}%`,
            top: '-10px',
            backgroundColor: piece.color,
            animation: `confetti-fall ${piece.duration}ms ease-out ${piece.delay}ms forwards`,
          }}
        />
      ))}
    </div>
  );
}
